<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div aria-live="assertive" class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
    <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
    <transition enter-active-class="transform ease-out duration-300 transition" enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enter-to-class="translate-y-0 opacity-100 sm:translate-x-0" leave-active-class="transition ease-in duration-100" leave-from-class="opacity-100" leave-to-class="opacity-0">
      <div v-if="$store.state.modalVisible" class="max-w-sm w-full bg-blue-600 shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
        <div class="p-4">
          <div class="flex items-start">
            <div v-if="$store.state.modalContent.icon" class="flex-shrink-0">
                <heroicon :icon="$store.state.modalContent.icon" class="w-6 h-6 text-blue-100"></heroicon>
              <!-- <CheckCircleIcon class="h-6 w-6 text-green-400" aria-hidden="true" /> -->
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="text-sm font-medium text-white">
                {{ $store.state.modalContent.title }}
              </p>
              <p v-if="$store.state.modalContent.description" class="mt-1 text-sm text-blue-50">
                {{ $store.state.modalContent.description }}
              </p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button @click="$store.commit('hideModal')" class="bg- rounded-md inline-flex text-blue-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                <span class="sr-only">Close</span>
                <heroicon icon="x" class="h-5 w-5" aria-hidden="true"></heroicon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
    components: {
        heroicon: () => import('./Heroicon')
    },
    props: {
        // title: { default: null },
        // description: { default: null }
    },
    watch: {
        '$store.state.modalVisible': 'autoHide'
    },
    methods: {
      autoHide() {
        setTimeout(() => this.$store.commit('hideModal'), this.$store.state.modalContent.duration || 2000);
      }
    },
    mounted() {
      // modalVisible may be true if another component loads
      // it very early on (e.g. on page load) and therefore
      // the watcher won't yet be configured. We manually run
      // the autoHide function to ensure it won't be permanently
      // open.
      if (this.$store.state.modalVisible) {
        this.autoHide();
      }
    }
}
</script>